import CustomerSupport from '../../assets/images/customer_support.png'

const Support = () => {

    return (
        <>
            <nav class="navbar bg-body-tertiary">
                <div class="container">
                    <a class="navbar-brand" href="/trial">
                        <img src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg" alt="Logo" />
                    </a>
                </div>
            </nav>
            <div style={{ height: '90vh' }} className='d-flex justify-content-center align-items-center'>
                <div className='text-center'>
                    <img src={CustomerSupport} class="rounded mx-auto d-block" alt="Customer support logo" />
                    <h2 className='mt-4'>Thank you for signing up!</h2>
                    <p className='lead'>To complete your registration, please check your email for a verification link. <br />If you don't see the email in your inbox, please check your spam or junk folder.</p>
                </div>
            </div>
        </>
    )
}

export default Support
